import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Divider } from 'antd'
import TouchInput from '../../../components/business/creport/touchInput'
import ReportFiles from '../../../components/business/creport/files'
import ReportBloodTestCharts from '../../../components/business/creport/charts'
import KeyTakeaway from '../../../components/business/creport/keyTakeaway'
import BloodTestResult from '../../../components/business/creport/bloodTest'
import { deleteAttachment } from '../../../api/file'
import imgaeICon from '../../../asserts/icon/drag-file-icon.svg'

export class ReportBloodTest extends Component {
  static propTypes = {
    report: PropTypes.object,
    addAttachment: PropTypes.func,
    updateReport: PropTypes.func,
    deleteAttachmentSync: PropTypes.func
  }

  state = {
    isDeleting: false
  }

  uploadFile = (file, progressCallback, source = null) => {
    const { addAttachment } = this.props
    addAttachment(
      'report.blood_test_media_files',
      file,
      progressCallback,
      source
    )
  }

  deleteFile = async (id) => {
    const { deleteAttachmentSync, person } = this.props
    const { isDeleting } = this.state
    if (isDeleting) return
    this.setState({ isDeleting: true })
    try {
      await deleteAttachment(id, person.id)
      this.setState({ isDeleting: false })
      deleteAttachmentSync('blood_test_media_files', id)
    } catch (err) {
      console.error(err)
    }
  }

  render() {
    const { report, updateReport } = this.props
    return (
      report && (
        <div>
          <TouchInput
            initialValue={report && report.blood_test_intro}
            placeholder="click to Add introduction"
            save={(value) => updateReport({ blood_test_intro: value })}
          />
          <Divider className="full" />
          <h1 className="section-title">Summary</h1>
          <TouchInput
            initialValue={report && report.blood_test_summary}
            placeholder="+ Click to add summary"
            save={(value) => updateReport({ blood_test_summary: value })}
          />
          {report.categorized_blood_test &&
            report.categorized_blood_test.length > 0 && (
              <ReportBloodTestCharts
                bloodTestResult={report.categorized_blood_test}
              />
            )}
          <h1 className="section-title">significant blood test</h1>
          <TouchInput
            initialValue={report && report.significant_blood_test_intro}
            placeholder="click to Add introduction"
            save={(value) =>
              updateReport({ significant_blood_test_intro: value })
            }
          />
          {report && report.categorized_blood_test && (
            <BloodTestResult result={report.categorized_blood_test} />
          )}
          <Divider className="full" />
          <h1 className="section-title">key takeaway</h1>
          <KeyTakeaway
            initialValue={report && report.blood_test_takeaway}
            update={(value) => updateReport({ blood_test_takeaway: value })}
          />
          <Divider className="full" />
          <ReportFiles
            uploadIcon={imgaeICon}
            save={(value) => updateReport({ blood_test_media_intro: value })}
            files={report.blood_test_media_files || []}
            introduction={report && report.blood_test_media_intro}
            upload={this.uploadFile}
            deleteFile={this.deleteFile}
          />
        </div>
      )
    )
  }
}

export default ReportBloodTest
